import { constants } from "@newsela/angelou";

import {
  SEARCH,
  BROWSE,
  VIEW_VIDEO_VEILED_TOP,
  VIEW_VIDEO_VEILED_BOTTOM,
  VIEW_VIDEO_VEILED_BOTTOM_POST_TRIAL,
  VIEW_ARTICLE_VEILED_TOP,
  VIEW_ARTICLE_VEILED_BOTTOM,
  VIEW_ARTICLE_VEILED_BOTTOM_POST_TRIAL,
  VIEW_ARTICLE_VEILED_BOTTOM_UNAUTHENTICATED,
  ADMIN_CONSOLE_ADMIN_TOOLS_CONTENT_SETTINGS,
  CAREGIVER_SUFFIX,
} from "./constants";
import SignUpLogInCta from "./NoAccessBanner/SignUpLogInCta";
import StartTrialCta from "./NoAccessBanner/StartTrialCta";

const white700 = constants.colors.ui.white["700"];

const coreBlue25 = constants.colors.ui.core[25];

const sharedWrapperProps = {
  css: {
    width: "100%",
    margin: "0",
    padding: "1px 0",
  },
};

// All admin views should have
// no margin for the banner.
const adminBannerSharedCssFor = {
  __cssFor: {
    root: {
      margin: "0",
    },
  },
};

const sharedWrapperPropsWithWhiteBg = {
  ...sharedWrapperProps,
  css: {
    ...sharedWrapperProps?.css,
    backgroundColor: white700,
  },
};

const sharedWrapperPropsWithBlueBg = {
  ...sharedWrapperProps,
  css: {
    ...sharedWrapperProps?.css,
    backgroundColor: coreBlue25,
  },
};

export default new Map([
  [
    SEARCH,
    {
      NoAccessBanner: {
        title: "Unlock curriculum-aligned content",
        body:
          "Find the just-right article, story, " +
          "video, or lesson for your next unit.",
      },
      Wrapper: sharedWrapperPropsWithWhiteBg,
    },
  ],
  [
    SEARCH + CAREGIVER_SUFFIX,
    {
      NoAccessBanner: {
        title: "Unlock curriculum-aligned content",
        body:
          "Find the just-right article, story, " +
          "video, or lesson for your next unit.",
      },
      Wrapper: sharedWrapperPropsWithWhiteBg,
    },
  ],
  [
    BROWSE,
    {
      NoAccessBanner: {
        title: "Unlock Newsela subjects",
        body:
          "Take core instruction to the " +
          "next level with a variety of " +
          "course-aligned content and " +
          "learning activities.",
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    BROWSE + CAREGIVER_SUFFIX,
    {
      NoAccessBanner: {
        title: "Unlock Newsela subjects",
        body:
          "Take core instruction to the next " +
          "level with a variety of course-aligned " +
          "content and learning activities.",
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    VIEW_VIDEO_VEILED_TOP,
    {
      NoAccessBanner: {
        title: "Unlock this video",
        body:
          "View and assign this video with " +
          "Newsela’s free trial. You’ll " +
          "get immediate and full access to this " +
          "and over 15,000 other articles, " +
          "stories, videos and lessons perfect " +
          "for your next unit.",
        whiteBgColor: true,
      },
      Wrapper: sharedWrapperPropsWithBlueBg,
    },
  ],
  [
    VIEW_VIDEO_VEILED_BOTTOM,
    {
      NoAccessBanner: {
        title: "Assign this video today",
        body:
          "Start a free trial to view and " +
          "assign this video to your students. " +
          "You’ll get full access to quizzes, " +
          "write prompts, annotations and Power " +
          "Words. Plus you’ll be able to review " +
          "and score student results.",
        ctaSection: StartTrialCta,
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    VIEW_VIDEO_VEILED_BOTTOM_POST_TRIAL,
    {
      NoAccessBanner: {
        title: "Unlock premium videos",
        body:
          "Premium content is available to schools " +
          "with subscriptions to Newsela’s premium " +
          "products. If you’d like access to content " +
          "like this, let your administrator know.",
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    VIEW_VIDEO_VEILED_BOTTOM + CAREGIVER_SUFFIX,
    {
      NoAccessBanner: {
        title: "Unlock premium videos",
        body:
          "Premium content is available to schools " +
          "with subscriptions to Newsela’s premium " +
          "products. If you’d like access to content " +
          "like this, let your administrator know.",
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    VIEW_ARTICLE_VEILED_TOP,
    {
      NoAccessBanner: {
        title: "Unlock this article",
        body:
          "Read and assign this article " +
          "with Newsela’s free trial. " +
          "You’ll get immediate and full access " +
          "to this and over 15,000 other articles, " +
          "stories, videos and lessons " +
          "perfect for your next unit.",
        whiteBgColor: true,
      },
      Wrapper: sharedWrapperPropsWithBlueBg,
    },
  ],
  [
    VIEW_ARTICLE_VEILED_BOTTOM,
    {
      NoAccessBanner: {
        title: "Assign this article today",
        body:
          "Start a free trial to view and " +
          "assign this article to your students. " +
          "You’ll get full access to quizzes, " +
          "write prompts, annotations and Power " +
          "Words. Plus you’ll be able to review " +
          "and score student results.",
        ctaSection: StartTrialCta,
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    VIEW_ARTICLE_VEILED_BOTTOM_POST_TRIAL,
    {
      NoAccessBanner: {
        title: "Unlock premium articles",
        body:
          "Premium content is available to schools " +
          "with subscriptions to Newsela’s premium " +
          "products. If you’d like access to content " +
          "like this, let your administrator know.",
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    VIEW_ARTICLE_VEILED_BOTTOM_UNAUTHENTICATED,
    {
      NoAccessBanner: {
        title: "View and assign this article today",
        body:
          "Log in to your Newsela account (or sign " +
          "up for free) to access reading content, " +
          "videos, and more.",
        ctaSection: SignUpLogInCta,
      },
      Wrapper: { ...sharedWrapperProps, "data-qa-selector": "unauth_banner" },
    },
  ],
  [
    VIEW_ARTICLE_VEILED_BOTTOM + CAREGIVER_SUFFIX,
    {
      NoAccessBanner: {
        title: "Unlock premium articles",
        body:
          "Premium content is available to schools " +
          "with subscriptions to Newsela’s premium " +
          "products. If you’d like access to content " +
          "like this, let your administrator know.",
      },
      Wrapper: sharedWrapperProps,
    },
  ],
  [
    ADMIN_CONSOLE_ADMIN_TOOLS_CONTENT_SETTINGS,
    {
      NoAccessBanner: {
        title: "Unlock Content Settings",
        body:
          "Upgrade to a subscription to view and " +
          "manage content visibility controls for " +
          "teachers and students. Premium admin " +
          "users get access to all our admin " +
          "console tools.",
        ...adminBannerSharedCssFor,
      },
      Wrapper: sharedWrapperProps,
    },
  ],
]);
